import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { CommonTarget } from './common-targeting';

export const Interest = ({ interests }) => {
  const i18n = useContext(I18nContext);

  return (
    <CommonTarget label={_TL_('Interest')} data={interests} pluralText={i18n.getString(_TL_('interests'))} singularText={i18n.getString(_TL_('interest'))} />
  );
};

Interest.propTypes = {
  interests: PropTypes.arrayOf(PropTypes.shape({})),
};

Interest.defaultProps = {
  interests: [],
};
